import { createIcon } from '../createIcon';

export const UnlockedIconConfig = {
  name: 'UnlockedIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M838.949 654.482c-17.115 162.597-159.232 296.375-325.193 296.375-177.079 0-329.216-152.21-329.216-329.216v-108.398h-112.055c-38.181-0.073-69.047-30.939-69.12-69.12v-443.977c0-38.107 31.013-73.728 69.12-71.387h880.201c38.107-2.267 69.12 33.28 69.12 71.387v444.050c-0.073 38.181-30.939 69.047-69.12 69.12l-623.104-0.073v108.398c0.219 101.595 82.505 183.954 184.101 184.101 88.869 0 161.426-65.682 178.176-149.358l147.017-1.829zM903.826 73.582h-541.403c-25.088 0-34.231 11.41-34.231 36.498s9.143 36.498 34.231 36.498h541.403c25.088 0 45.641-11.41 45.641-36.498s-20.553-36.425-45.641-36.425v-0.073zM903.826 292.571h-541.403c-25.088 0-34.231 11.41-34.231 36.498s9.143 36.498 34.231 36.498h541.403c25.088 0 45.641-11.41 45.641-36.498s-20.553-36.425-45.641-36.425v-0.073z',
  yOffset: 64,
  xOffset: 0,
  transform: 'rotate(180 0 512) scale(-1 1)'
};

export const UnlockedIcon = createIcon(UnlockedIconConfig);

export default UnlockedIcon;